"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _flagIcon = _interopRequireDefault(require("flag-icon-css/css/flag-icon.css"));

var _main = _interopRequireDefault(require("./styles/main.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var finalStyles = _objectSpread({}, _flagIcon.default, _main.default);

var _default = finalStyles;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/styles.js
// module id = 345
// module chunks = 168707334958949